import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColumn } from 'src/components/GridWrapper';
import useWindowSize from 'src/hooks/useWindowSize';
import AttributesCell from 'src/sections/catalog_products/table_cell/AttributesCell';
import PunchoutOrderGuideAttributesFilter from 'src/sections/punchout_order_guide/table_cell/PunchoutOrderGuideAttributesFilter';
import { PunchoutOrderGuideItem } from 'src/types/punchout-order-guide/PunchoutOrderGuideItem';

const usePunchoutOrderGuideColumns = (): GridColumn<PunchoutOrderGuideItem>[] => {
  const { t } = useTranslation();
  const { width } = useWindowSize();
  const gridWidth = useMemo(() => Math.max(width, 1200), [width]);
  const setPercentage = useMemo(
    () => (percentage: number) => Math.round((gridWidth / 100) * percentage),
    [gridWidth]
  );

  return useMemo(
    () => [
      {
        field: 'attributes',
        title: t('Attributes'),
        filter: 'text',
        sortable: false,
        menu: true,
        show: true,
        width: setPercentage(7),
        minResizableWidth: 70,
        dataType: 'fixed',
        component: AttributesCell,
        columnMenu: PunchoutOrderGuideAttributesFilter,
      },
      {
        field: 'itemNum',
        title: t('Item #'),
        filter: 'text',
        sortable: true,
        menu: true,
        show: true,
        width: setPercentage(8),
        minResizableWidth: 80,
        dataType: 'string',
      },
      {
        field: 'brand',
        title: t('Brand Name'),
        filter: 'text',
        sortable: true,
        menu: true,
        show: true,
        width: setPercentage(10),
        minResizableWidth: 90,
        dataType: 'string',
      },
      {
        field: 'description',
        title: t('Description'),
        filter: 'text',
        sortable: true,
        menu: true,
        show: true,
        width: setPercentage(36),
        minResizableWidth: 200,
        dataType: 'string',
      },
      {
        field: 'catalog',
        title: t('Catalog'),
        filter: 'text',
        sortable: true,
        menu: true,
        show: true,
        width: setPercentage(23),
        minResizableWidth: 140,
        dataType: 'string',
      },
      {
        field: 'maxNum',
        title: t('Max #'),
        filter: 'numeric',
        sortable: true,
        menu: true,
        show: true,
        width: setPercentage(8),
        minResizableWidth: 60,
        dataType: 'number',
      },
      {
        field: 'uom',
        title: t('UOM'),
        filter: 'text',
        sortable: true,
        menu: true,
        show: true,
        width: setPercentage(8),
        minResizableWidth: 60,
        dataType: 'string',
      },
    ],
    [setPercentage, t]
  );
};

export default usePunchoutOrderGuideColumns;
